import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleGovernateStatus = (_variables) => {
    let responseFromApi;
    responseFromApi = apolloClient
        .mutate({
            mutation: require("@/settings/api/mutations/governates/toggle_governate.graphql"),
            variables: _variables,
            update: (store, { data }) => {
                const query = {
                    query: require("@/settings/api/queries/governates/governate_query.graphql"),
                    variables: {
                        input: {
                            limit: 10,
                            skip: 0
                        },
                        filter: {
                            searchKey: ''
                        }
                    },
                };
                store.writeQuery({
                    ...query,
                    data: data,
                });
            },
        })
        .catch((error) => {
            return error;
        });
    return responseFromApi;
};
export { toggleGovernateStatus };
